export default __webpack_public_path__ + "static/media/exam.fee7bf8a.jpg";